import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e71c5808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-detail" }
const _hoisted_2 = { class: "user-detail__content" }
const _hoisted_3 = { class: "user-detail__about" }
const _hoisted_4 = { class: "user-detail__header" }
const _hoisted_5 = { class: "text-bold" }
const _hoisted_6 = { class: "user-detail__subtitle" }
const _hoisted_7 = { class: "user-detail__info" }
const _hoisted_8 = { class: "user-detail__info-item" }
const _hoisted_9 = { class: "user-detail__info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "user-detail__info-item" }, "Организации:", -1))
const _hoisted_11 = { class: "user-detail__organizations" }
const _hoisted_12 = { class: "user-detail__organizations-item" }
const _hoisted_13 = { class: "user-detail__report" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-detail__report-content user-detail__report-content--active" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "user-detail__report-title" }, "Статистика врача"),
  /*#__PURE__*/_createElementVNode("p", { class: "user-detail__report-description" }, " по всем отчётам за период ")
], -1))
const _hoisted_15 = { class: "divider" }

import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { EUserDetailCard } from '@/entities/EUserDetailCard'
import { useRouter, useRoute } from 'vue-router'
import { userApi, usersApi } from '@/shared/api'
import { UserType, AdminReportType, RemoteUserReportType } from '@/shared/types'
import { showErrorMessage, getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const loading = ref(false)

const user = ref<UserType>({
  email: '',
  id: 0,
  name: '',
  organization: [],
  position: '',
  reports_count: 0,
  role: '',
})

const reports = ref<AdminReportType[]>([])

const userId = computed<string | string[]>(() => route.params.userId)
const organizationId = computed<string | string[]>(
  () => route.params.organizationId
)

watch(userId, (newUserId) => {
  if (newUserId) {
    getUserInfo()
  }
})

watch(organizationId, (newOrganizationId) => {
  if (newOrganizationId && newOrganizationId !== 'all') {
    getUserInfo()
  }
})

const getUserInfo = async (): Promise<void> => {
  loading.value = true

  await getUser()
  await getReports()

  loading.value = false
}

const getUser = async (): Promise<void> => {
  const [error, response] = await userApi.getUser(Number(userId.value))

  if (error) {
    showErrorMessage(error)
  } else {
    user.value = response.data.user
  }
}

const getReports = async (): Promise<void> => {
  if (!userId.value || !organizationId.value) return

  const [error, response] = await usersApi.getUserReports(
    Number(userId.value),
    Number(organizationId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    await setReportsInfo(response.data.reports)
  }
}

const setReportsInfo = async (
  originReports: RemoteUserReportType[]
): Promise<void> => {
  reports.value = []

  for (const report of originReports) {
    const index = JSON.parse(report.index)

    const patient = report.patient_id
      ? report.patient_id.toString()
      : 'null-patient'
    let percentage
    if (index?.index) {
      percentage = index
        ? Math.round(
            (index.index.day + index.index.week + index.index.month) * 100
          )
        : 0
    } else {
      percentage = index
        ? Math.round((index.day + index.week + index.month) * 100)
        : 0
    }

    const newReport: AdminReportType = {
      id: report.id,
      date: getDateFormat(new Date(report.date_at), DATE_FORMAT.dmyDash),
      percentage,
      patient,
    }

    reports.value.push(newReport)
  }
}

const handleOpenUserEditionPage = (): void => {
  router.push({
    name: 'UserEditionPage',
    params: { userId: userId.value },
  })
}

onMounted((): void => {
  getUserInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(user.value.name), 1),
          _createVNode(_component_icon_template, {
            class: "user-detail__icon",
            name: "tools",
            width: "12",
            height: "12",
            onClick: handleOpenUserEditionPage
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, "№" + _toDisplayString(user.value.id), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, "Почта: " + _toDisplayString(user.value.email), 1),
          _createElementVNode("p", _hoisted_9, "Роль: " + _toDisplayString(user.value.role), 1),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.organization, (organization) => {
              return (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(organization.name), 1))
            }), 256))
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_scrollbar, { class: "user-detail__reports" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_divider)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report) => {
          return (_openBlock(), _createBlock(_unref(EUserDetailCard), {
            key: report.id,
            report: report
          }, null, 8, ["report"]))
        }), 128))
      ]),
      _: 1
    })
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})